export default "__VITE_ASSET__6c52d8d5__"